import { render, staticRenderFns } from "./question-message.vue?vue&type=template&id=109b3f5e&"
import script from "./question-message.vue?vue&type=script&lang=js&"
export * from "./question-message.vue?vue&type=script&lang=js&"
import style0 from "./question-message.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports